import { LargeListSkeleton } from '@Components/General/Skeletons';
import { createFileRoute } from '@tanstack/react-router';
import { contactsGroupsQueryOptions } from '@utils/queryOptions';
import Groups from '@Views/Contacts/groups';

export const Route = createFileRoute('/contacts/groups/')({
    component: Groups,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            contactsGroupsQueryOptions(opts.deps),
        ),
    loaderDeps: ({ search }) => search,
    pendingComponent: LargeListSkeleton,
});
